export enum IfGateDateTimeFormatType {
	ISO,
	Custom,
}
